import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Tilty from 'react-tilty';
import { Button, Skeleton, Tooltip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const specialPool = {
    "title": "Knights Round",
    "target_raise": "$2,600,000",
    "token_price": "$0.006",
    "tokens_allocated": "433,333,333",
    "discount_vs_public_($0.01)": "40%",
    "fast_mover_bonus": "Early allocation + priority for community pools",
    "min_buy": "$50,000",
    "progress": "100",
    "type": "special",
    "end-date": "2025-07-01T12:00"
}

const SecuredPoolCards = ({ privatePools, CountdownTimer, isLoading }) => {
    const navigate = useNavigate();
    const [poolsData, setPoolsData] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);


    useEffect(() => {
        const poolsToRender = isLoading ? new Array(3).fill({}) : [specialPool, ...privatePools];
        setPoolsData(poolsToRender);
    }, [privatePools, isLoading]);

    const handleParticipate = (pool) => {
        navigate(`/presale/participate`, { state: { pool } });
    };

    const CustomSkeleton = ({ width, height, rounded = false, style = {} }) => (
        <Skeleton
            variant="rectangular"
            width={width}
            height={height}
            sx={{
                bgcolor: 'rgba(255, 255, 255, 0.12)',
                transform: 'none',
                borderRadius: rounded ? '8px' : '4px',
                ...style,
            }}
        />
    );

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                {/* <Tilty max={2} perspective={800}>
                    <h2 style={{ color: '#fff', fontSize: 26, margin: 0 }}>
                        PRIVATE POOLS
                    </h2>
                </Tilty> */}

                {/* <div style={{ color: '#fff', fontSize: 24, display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 10 }}>Total Value Locked:</span>
                    <strong style={{ fontSize: 30, color: '#efbc00' }}> 
                        $XX,XXX.XX
                    </strong>
                </div> */}
            </div>


            <div
                className={`row ${poolsData.length === 4 ? 'justify-content-center' : ''}`}
                style={{ maxWidth: 1440, margin: '0 auto', paddingLeft: 8, paddingRight: 8 }}
            >
                {poolsData.map((pool, index) => (

                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex justify-content-center" key={index} style={{ marginBottom: 20 }}>

                        <Tilty
                            max={8}
                            perspective={800}
                            style={{
                                transform: 'perspective(800px)',
                                '& .tilty-inner': {
                                    transform: 'scale(1.05)',
                                    transformStyle: 'preserve-3d',
                                }
                            }}
                        >
                            <div
                                style={{
                                    flex: 1,
                                    width: '100%',
                                    padding: 24,
                                    backgroundColor: '#111',
                                    backdropFilter: 'blur(6px)',
                                    boxShadow: pool.type === "special"
                                        ? '0 0 15px 4px rgba(255, 215, 0, 0.7), 0 0 25px 10px rgba(255, 255, 255, 0.2) inset'
                                        : '0 2px 14px rgba(0,0,0,0.2)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    transition: 'transform 0.3s ease, background-color 0.3s ease',
                                    cursor: 'default',
                                    border: '2px solid #2d9f56',
                                    borderRadius: 15,
                                    animation: pool.type === "special" ? 'glowFlash 1s ease-in-out infinite alternate' : 'none',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.backgroundColor = 'rgba(0, 149, 68, 0.13)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.backgroundColor = '#111';
                                }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                                    {isLoading ? (
                                        <CustomSkeleton width={180} height={32} rounded />
                                    ) : (
                                        <h4 style={{ fontSize: 18, margin: 0, color: '#fff', fontWeight: 700 }}>
                                            {pool.title}
                                        </h4>
                                    )}
                                    <div style={{ textAlign: 'right' }}>
                                        {isLoading && (
                                            <CustomSkeleton width={150} height={24} rounded />
                                        )}

                                        {!isLoading && pool.type !== 'special' && pool.progress < 100 ? (
                                            <CountdownTimer targetDate={pool['end-date']} fontSize={15} title="Pool ends in:" endTitle="Presale ended"/>
                                        ) : (
                                            <div style={{ fontSize: 15, color: '#efbc00' }}>
                                                {pool.target_raise && pool.progress && (
                                                    <>
                                                        Total Raised: {
                                                            (() => {
                                                                const numeric = parseFloat(pool.target_raise.replace(/[^0-9.]/g, '').replace(/,/g, ''));
                                                                const raised = (numeric * (pool.progress / 100)).toLocaleString('en-US', {
                                                                    style: 'currency',
                                                                    currency: 'USD',
                                                                    minimumFractionDigits: 0,
                                                                });
                                                                return raised;
                                                            })()
                                                        }
                                                    </>
                                                )}
                                            </div>
                                        )}

                                    </div>
                                </div>

                                <div style={{ height: 2, backgroundColor: '#2d9f56', marginBottom: 16 }} />

                                <div className="row" style={{ color: '#fff', marginBottom: 16 }}>
                                    {[
                                        { label: pool.type == 'special' ? 'Total Raised:' : 'Target Raise:', value: pool.target_raise, col: 6, width: 140 },
                                        { label: 'Discount vs Public:', value: pool['discount_vs_public_($0.01)'], col: 6, highlight: true, width: 160 },
                                        { label: 'Fast Mover Bonus:', value: pool.fast_mover_bonus, col: 6, italic: true, width: 140 },
                                        { label: 'Minimum Buy:', value: pool.min_buy, col: 6, width: 100 },
                                        { label: 'Tokens Allocated:', value: pool.tokens_allocated, col: 6, large: true, width: 160 },
                                        { label: 'Token Price:', value: pool.token_price, col: 6, large: true, bold: true, width: 120 }
                                    ].map((item, i) => (
                                        <div className={`col-12 col-md-${item.col}`} style={{ marginBottom: 12 }} key={i}>
                                            <div style={{ marginBottom: 4 }}>
                                                {isLoading ? (
                                                    <CustomSkeleton width={item.width} height={item.large ? 24 : 20} rounded />
                                                ) : (
                                                    <strong style={{ color: item.highlight ? '#efbc00' : '#bbb' }}>
                                                        {item.label}
                                                    </strong>
                                                )}
                                            </div>
                                            <div style={{
                                                fontSize: item.large ? 14 : 12,
                                                fontWeight: item.bold ? 600 : 'inherit',
                                                color: item.highlight ? '#efbc00' : item.italic ? '#8de47d' : 'inherit',
                                                fontStyle: item.italic ? 'italic' : 'normal',
                                                lineHeight: '1.2'
                                            }}>
                                                {isLoading ? (
                                                    <CustomSkeleton
                                                        width={item.width}
                                                        height={item.large ? 24 : 20}
                                                        rounded
                                                    />
                                                ) : item.value}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <Tooltip
                                    title={
                                        pool.progress >= 100 || pool.type === 'special' ? (
                                            <div style={{ padding: 12 }}>
                                                <div style={{ fontSize: 14, fontWeight: 600, color: '#efbc00' }}>
                                                    Presale Ended
                                                </div>
                                                <div style={{ fontSize: 14, color: '#ded6b7', marginTop: 8 }}>
                                                    This pool has reached 100% of its goal and is now closed.
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{ padding: 12 }}>
                                                <div style={{ color: '#67d36d', fontSize: 15, fontWeight: 600 }}>
                                                    {!isLoading && (
                                                        <CountdownTimer targetDate={pool['end-date']} fontSize={15} title="Pool ends in:" endTitle="Presale ended"/>
                                                    )}
                                                </div>
                                                <div style={{ color: '#ded6b7', fontSize: 16, marginTop: 8 }}>
                                                    <p>
                                                        <WarningAmberIcon sx={{ color: '#efbc00', fontSize: 12, marginRight: 1 }} />
                                                        This pool will close when the countdown ends.
                                                    </p>
                                                    <p>    <WarningAmberIcon sx={{ color: '#efbc00', fontSize: 12, marginRight: 1 }} />
                                                        Make sure to participate before time runs out!
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    }
                                    arrow
                                    followCursor
                                    PopperProps={{
                                        modifiers: [{ name: 'offset', options: { offset: [0, 10] } }]
                                    }}
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: '#0d260a',
                                                fontSize: 6,
                                                maxWidth: 300,
                                                border: '1px solid #efbc00',
                                                borderRadius: 2,
                                                padding: 1
                                            }
                                        }
                                    }}
                                >

                                    <div style={{ marginTop: 16 }}>
                                        <div
                                            style={{
                                                position: 'relative',
                                                height: 48,
                                                backgroundColor: isLoading ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 149, 68, 0.15)',
                                                borderRadius: 30,
                                                overflow: 'hidden',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '0 15px',
                                                fontStyle: 'italic',
                                                fontWeight: 600,
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {!isLoading && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        height: '100%',
                                                        width: `${Math.min(pool.progress || 0, 100)}%`,
                                                        backgroundImage: 'repeating-linear-gradient(45deg, #67d36d, #67d36d 6px, #56c45d 6px, #56c45d 12px)',
                                                        backgroundColor: '#67d36d',
                                                        opacity: 0.9,
                                                        transition: 'width 0.3s ease-in-out',
                                                        zIndex: 1,
                                                    }}
                                                />
                                            )}

                                            <div style={{ flex: 1, color: '#fff', textAlign: 'center', zIndex: 2 }}>
                                                {isLoading ? <CustomSkeleton width="100%" height={24} rounded /> : `${pool.progress}% sold`}
                                            </div>

                                            {!isLoading && (
                                                <div style={{ zIndex: 2 }}>
                                                    {pool.progress && pool.progress < 100 ? (
                                                        <Button
                                                            onClick={() => handleParticipate(pool)}
                                                            variant="contained"
                                                            color="success"
                                                            size="small"
                                                            style={{
                                                                fontSize: 12,
                                                                fontWeight: 600,
                                                                padding: '4px 16px',
                                                                textTransform: 'none',
                                                                borderRadius: 20,
                                                                marginLeft: 10,
                                                            }}
                                                        >
                                                            Participate
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            size="small"
                                                            sx={{
                                                                fontSize: 12,
                                                                fontWeight: 600,
                                                                padding: '4px 16px',
                                                                textTransform: 'none',
                                                                borderRadius: 20,
                                                                marginLeft: 1.25,
                                                                backgroundColor: '#dba700',
                                                                color: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: '#c39000',
                                                                },
                                                            }}
                                                        >
                                                            Presale Ended
                                                        </Button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Tooltip>

                            </div>
                        </Tilty>
                    </div >

                ))}
            </div >
        </>
    );
};

export default SecuredPoolCards;